import { render } from "./ThePatientHome.vue?vue&type=template&id=24b99f4f&ts=true"
import script from "./ThePatientHome.vue?vue&type=script&lang=ts"
export * from "./ThePatientHome.vue?vue&type=script&lang=ts"

import "./ThePatientHome.vue?vue&type=style&index=0&id=24b99f4f&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__